import TranDetails from './TranDetails';

export default TranDetails;